module.exports = __webpack_public_path__ + "static/media/documentSearchIcon.87b94101.svg";